import { Injectable } from '@angular/core';
import { RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../api.service';
import { Favourite, FavouriteCollectionMember } from 'ri-api-client';
import { Kml, KmlCollectionMember } from 'ri-api-client';

@Injectable()
export class KmlsService {

  public kmls: Kml.Kml[] = [];

  constructor(
    private apiService: ApiService
  ) {
    this.apiService.init();
  }

  get(): Observable<KmlCollectionMember.KmlCollectionMember> {
    return this.apiService.client.kmls.GET()
      .map((res) => {
        return this.kmls = this.apiService.handleResponse(res);
      });
  }

  getKmls(): Promise<Kml.Kml[]> {
    return this.apiService.client.kmls.GET()
      .map((res) => {
        return this.apiService.handleResponse(res);
      })
      .toPromise();
  }

  getById(id: number): Observable<Kml.Kml> {
    return this.apiService.client.kmls.id(id.toString()).GET()
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  post(kml: any): Observable<any[]> {
    const headers = new Headers({ 'Content-Type': 'multipart/form-data'});
    const options = new RequestOptions({ headers: headers });
    return this.apiService.client.kmls.POST(kml, options)
      .map((res) => {
        const response = this.apiService.handleResponse(res);
        this.kmls.push(response);
        return response;
      });
  }

  update(kml: Kml.Kml): Observable<any[]> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    this.kmls[this.kmls.findIndex(x => x.id === kml.id)] = kml;
    return this.apiService.client.kmls.id(kml.id.toString()).PATCH(kml, options)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  delete(kml: Kml.Kml): Observable<any[]> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    this.kmls.splice(this.kmls.findIndex(x => x.id === kml.id), 1);
    return this.apiService.client.kmls.id(kml.id.toString()).DELETE(options)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/api/kmls.service.ts